import { render, staticRenderFns } from "./RankingList.vue?vue&type=template&id=a64bae04&scoped=true&"
import script from "./RankingList.vue?vue&type=script&lang=js&"
export * from "./RankingList.vue?vue&type=script&lang=js&"
import style0 from "./RankingList.vue?vue&type=style&index=0&id=a64bae04&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64bae04",
  null
  
)

export default component.exports